import { useAuth } from "../../auth/context";
import config from "../../config";
import _ from "lodash";
import { findHealthCenterConfig } from "../healthCenterConfig";

export const getHealthCenterRules = (healthCenterId, module) => {
  const healthCenterConfig = findHealthCenterConfig(config.healthCentersRules, healthCenterId);
  return _.get(healthCenterConfig, `rules.${module}`, {});
};

export default module => {
  const { user } = useAuth();
  const healthCenterId = user.profile?.healthCenter?.id || user.myHealthCenter?.id;
  return getHealthCenterRules(healthCenterId, module);
};